import 'isomorphic-fetch';
import 'font-awesome/css/font-awesome.min.css';
import '@elotech/arc/src/assets/less/compiled/portaltransparencia.css';

import App from './app/App.js';
import BootstrapErrorPage from 'portaltransparencia-common/components/BootstrapErrorPage.react.js';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import React from 'react';
import { Router } from 'react-router';
import changePrimaryColor from './changeColor';
import { configure } from 'portaltransparencia-common/config/Config.js';
import configureStore from 'portaltransparencia-common/config/ConfigureStore.js';
import { createBrowserHistory } from 'history';
import { fetchInitialState } from './FetchInitialState.js';
import { render } from 'react-dom';
import rootReducer from './app/Reducer.js';

const configuration = configure({
  apiURL: '/portaltransparencia-api',
  modulo: '34'
});

const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL
});
const store = configureStore(
  '../portaltransparencia/src/app/Reducer',
  rootReducer,
  configuration.apiURL,
  history
);

const app = document.getElementById('root');
const locale = (navigator.languages && navigator.languages[0]) || 'pt';

/* eslint-disable no-console */
fetchInitialState(store)
  .then(() => {
    console.log('Estado inicial carregado!!!');

    const onLoad = () => {
      bootstrapApp();
    };
    loadTemplate(onLoad);
  })
  .catch(err => {
    const message = 'Falha ao carregar o estado inicial da aplicação!';
    console.error(message, err);
    if (err.action) {
      render(<BootstrapErrorPage message={message} error={err} />, app);
    } else {
      bootstrapApp();
    }
  });
/* eslint-enable no-console */

function loadTemplate(onLoad) {
  let urlImagem = store
    .getState()
    .entidade.getIn(['configuracoesGerais', 'urlImagem']);
  if (urlImagem) {
    var styleCustomImage = document.createElement('style');
    styleCustomImage.innerHTML = `
      .portal .pt-home:before { background-image: url(${urlImagem})!important };
      .portal .page-header .page-header-title:after { background-image: url(${urlImagem})!important };
    `;
    document.head.appendChild(styleCustomImage);
  }

  const cor = store.getState().entidade.getIn(['configuracoesGerais', 'cor']);
  changePrimaryColor(cor);
  onLoad();
}

function bootstrapApp() {
  render(
    <Provider store={store}>
      <IntlProvider locale={locale}>
        <Router history={history}>
          <App history={history} />
        </Router>
      </IntlProvider>
    </Provider>,
    app
  );
}
